import React from "react";
import { observer } from "mobx-react";
import { AiSearchAutoEvalViewStore } from "../../store";
import { AiSearchAutoEvalViewForm } from "./AiSearchAutoEvalViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type AiSearchAutoEvalViewProps = {
  aiSearchAutoEvalViewStore: AiSearchAutoEvalViewStore;
};

export const AiSearchAutoEvalView: React.FC<AiSearchAutoEvalViewProps> =
  observer(({ aiSearchAutoEvalViewStore }) => {
    return (
      <div>
        <AiSearchAutoEvalViewForm
          runId={aiSearchAutoEvalViewStore.runIdValue}
          queryIndex={aiSearchAutoEvalViewStore.queryIndexValue}
          condition={aiSearchAutoEvalViewStore.conditionValue}
          includeSchema={aiSearchAutoEvalViewStore.includeSchemaValue}
          includeExamples={aiSearchAutoEvalViewStore.includeExamplesValue}
          query={aiSearchAutoEvalViewStore.queryValue}
          pathType={aiSearchAutoEvalViewStore.pathTypeValue}
          expectedTool={aiSearchAutoEvalViewStore.expectedToolValue}
          expectedEntity={aiSearchAutoEvalViewStore.expectedEntityValue}
          actualTool={aiSearchAutoEvalViewStore.actualToolValue}
          actualEntity={aiSearchAutoEvalViewStore.actualEntityValue}
          actualArgs={aiSearchAutoEvalViewStore.actualArgsValue}
          l1Pass={aiSearchAutoEvalViewStore.l1PassValue}
          l2Pass={aiSearchAutoEvalViewStore.l2PassValue}
          errorType={aiSearchAutoEvalViewStore.errorTypeValue}
          totalTimeMs={aiSearchAutoEvalViewStore.totalTimeMsValue}
          llmCallCount={aiSearchAutoEvalViewStore.llmCallCountValue}
          toolCallCount={aiSearchAutoEvalViewStore.toolCallCountValue}
          tokenCount={aiSearchAutoEvalViewStore.tokenCountValue}
          llmResponse={aiSearchAutoEvalViewStore.llmResponseValue}
          toolCalls={aiSearchAutoEvalViewStore.toolCallsValue}
          evaluatedAt={aiSearchAutoEvalViewStore.evaluatedAtValue}
          hadDisambiguation={aiSearchAutoEvalViewStore.hadDisambiguationValue}
          disambiguationType={aiSearchAutoEvalViewStore.disambiguationTypeValue}
          disambiguationResponse={
            aiSearchAutoEvalViewStore.disambiguationResponseValue
          }
          patternsApplied={aiSearchAutoEvalViewStore.patternsAppliedValue}
          l3Efficiency={aiSearchAutoEvalViewStore.l3EfficiencyValue}
          l4Redundancy={aiSearchAutoEvalViewStore.l4RedundancyValue}
          l5Disambiguation={aiSearchAutoEvalViewStore.l5DisambiguationValue}
          l6ResponseQuality={aiSearchAutoEvalViewStore.l6ResponseQualityValue}
          overallScore={aiSearchAutoEvalViewStore.overallScoreValue}
          judgeEvaluation={aiSearchAutoEvalViewStore.judgeEvaluationValue}
          redundantCalls={aiSearchAutoEvalViewStore.redundantCallsValue}
          actualCallCount={aiSearchAutoEvalViewStore.actualCallCountValue}
          optimalCallCount={aiSearchAutoEvalViewStore.optimalCallCountValue}
          sequenceMatchedOptimal={
            aiSearchAutoEvalViewStore.sequenceMatchedOptimalValue
          }
          response={aiSearchAutoEvalViewStore.responseValue}
          onPrint={(handlePrint: () => void) =>
            aiSearchAutoEvalViewStore.printAiSearchAutoEval(handlePrint)
          }
          onCancel={() => aiSearchAutoEvalViewStore.cancelAiSearchAutoEval()}
          onEdit={
            aiSearchAutoEvalViewStore.isEditEnabled
              ? () => aiSearchAutoEvalViewStore.editAiSearchAutoEval()
              : undefined
          }
        />
        <ErrorDialog
          open={aiSearchAutoEvalViewStore.errorDialogOpened}
          title={aiSearchAutoEvalViewStore.errorTitle}
          description={aiSearchAutoEvalViewStore.errorDescription}
          onClose={() => aiSearchAutoEvalViewStore.closeErrorDialog()}
        />
      </div>
    );
  });
